export interface IMouseEventExtension extends MouseEvent {
  path?: Array<HTMLElement>;
}

function intersection(sourceList?: Array<unknown>, findList?: Array<unknown>) {
  if (!sourceList || !findList) return false;

  let arr1: Array<unknown> = [];
  let arr2: Array<unknown> = [];
  if (sourceList.length > findList.length) {
    arr1 = findList;
    arr2 = sourceList;
  } else {
    arr1 = sourceList;
    arr2 = findList;
  }
  // 总是让小的数组进行循环，大的数组进行查找
  return arr1.some(item1 => arr2.includes(item1));
}

/*
* 用于判断，鼠标事件是否发生在指定标签外
* */
export function targetOutsideElement(
  event: MouseEvent,
  el: HTMLElement | Array<HTMLElement>,
): boolean {
  if (!event || !el) return true;
  // 类似 chrome 浏览器会有 path 属性
  const paths = (event as IMouseEventExtension)?.path;
  const elList = Array.isArray(el) ? el : [el];
  // chrome event path 不稳定，只有在确切有交集的情况下，才返回，如果没交集，就走老逻辑
  if (intersection(paths, elList)) {
    return false;
  }
  let targetEl = event.target as HTMLElement | null | undefined;
  while (targetEl?.parentElement && targetEl !== document.body && !elList.includes(targetEl)) {
    targetEl = targetEl?.parentElement;
  }
  return !targetEl || !elList.includes(targetEl);
}
